import { mapActions } from "vuex";

export default {
  data() {
    return {
      EquipmentState: null,
    };
  },
  mounted() {
    this.getEquipment();
  },
  methods: {
    ...mapActions(["getEquipmentState"]),
    getEquipment() {
      this.getEquipmentState();
      this.EquipmentState = this.$store.state.equipmentState;
    },
  },
};
